







































































































import {
  defineComponent,
  onMounted,
  reactive,
  ref,
  watch,
} from '@vue/composition-api';
import PrettyCheck from 'pretty-checkbox-vue/check';
import { useFormat, useRouter } from '@ideavivat/vivat-2';
import _ from 'lodash';

import speaker from '@/table/speaker';

import {
  getSpeakers,
  deleteSpeaker,
  deleteSpeakers,
} from '@/api';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';

const List = defineComponent({
  components: {
    PrettyCheck,
    CommonModalWithPreset,
  },
  setup() {
    const { route, routerPersist, router } = useRouter(['searchString', 'searchStatus']);
    // const { isMobile } = useScreenWidth();

    const loading = ref(true);
    const speakers = ref([]);
    const pagination = ref({
      // eslint-disable-next-line
      current_page: 1,
    });
    const page = ref(1);
    const sort = ref({ field: 'created_at', order: 'ASC' });

    const from = ref('');
    const to = ref('');
    const searchString = ref('');
    const searchStatus = ref('');

    const callGetSpeakers = _.debounce(async () => {
      loading.value = true;
      const { data, ...paginatorData } = await getSpeakers(
        page.value,
        30,
        sort.value,
      );
      speakers.value = data.map((elm: any) => ({ ...elm, _secondaryControls: false }));
      pagination.value = paginatorData;
      loading.value = false;
    }, 500);

    const pendingSearch = _.debounce(async () => {
      page.value = 1;
      await callGetSpeakers();
    }, 500);

    onMounted(async () => {
      await callGetSpeakers();
    });

    watch(() => page.value, async (newVal) => {
      // eslint-disable-next-line
      if (newVal !== pagination.value.current_page) {
        await callGetSpeakers();
      }
    });
    const handleSortChange = (sortParam: { field: string; order: string }) => {
      sort.value = sortParam;
    };
    watch(() => sort.value, async (newVal, oldVal) => {
      // eslint-disable-next-line
      if (newVal !== oldVal) {
        await callGetSpeakers();
      }
    });

    const navigateToDate = (date: any) => {
      if (useFormat.date(date).computerShortDate() === useFormat.date(route.value.query.date).computerShortDate()) {
        router.push({
          name: 'SpeakerList',
        });
      } else {
        router.push({
          name: 'SpeakerList',
          query: {
            date: useFormat.date(date).computerShortDate(),
          },
        });
      }
    };
    watch(() => route.value.query.date, async (newVal, oldVal) => {
      // eslint-disable-next-line
      if (newVal !== oldVal) {
        from.value = newVal;
        to.value = newVal;
        await callGetSpeakers();
      }
    });

    const setActiveStatus = (id: number, status: boolean) => {
      const index = speakers.value.findIndex((elm: any) => elm.id === id);
      (speakers.value[index] as any).status = status;
    };

    // ==================== //
    // Use with select item //
    const selectedItems: number[] = reactive([]);
    const selectItem = (id: number, status: boolean) => {
      if (status) {
        const removeIndex = selectedItems.findIndex((elm: any) => elm === id);
        if (removeIndex > -1) selectedItems.splice(removeIndex, 1);
      } else {
        selectedItems.push(id);
      }
      const index = speakers.value.findIndex((elm: any) => elm.id === id);
      (speakers.value[index] as any)._secondaryControls = !status;
    };
    const selectAllItems = () => {
      if (selectedItems.length > 0) selectedItems.splice(0, selectedItems.length);
      speakers.value.forEach((elm: any, index: number) => {
        (speakers.value[index] as any)._secondaryControls = true;
        selectedItems.push(elm.id);
      });
    };
    const unselectAllItems = () => {
      selectedItems.splice(0, selectedItems.length);
      speakers.value.forEach((elm: any, index: number) => {
        (speakers.value[index] as any)._secondaryControls = false;
      });
    };

    // Delete fn
    const deleteItemModal = ref(null);
    const deleteItemsModal = ref(null);
    const openDeleteItemModal = (item: any) => {
      (deleteItemModal.value as any).compose({
        id: item.id,
        action: 'ลบ',
        entity: 'ผู้พูด',
        body: `เป็นการลบ<br>${item.name}<br>จากระบบโดยถาวร<br>ไม่สามารถย้อนคืนได้`,
      });
    };
    const deleteItemAction = async (id: number) => {
      const result = await deleteSpeaker(id);
      await callGetSpeakers();
    };
    const deleteItemsAction = async () => {
      const result = await deleteSpeakers(selectedItems);
      await callGetSpeakers();
    };

    return {
      speakers,
      speakerTableOptions: speaker,
      page,
      pagination,
      loading,
      searchString,
      searchStatus,
      from,
      to,

      pendingSearch,

      sort,
      handleSortChange,

      navigateToDate,
      setActiveStatus,

      selectItem,
      selectAllItems,
      selectedItems,
      unselectAllItems,

      openDeleteItemModal,
      deleteItemAction,
      deleteItemsAction,
      deleteItemModal,
      deleteItemsModal,
    };
  },
});

export default List;
